import {GeofenceEventEntity,} from "@ots-frontend/ots-data";
import {useCallback} from "react";
import {useNavigate} from "react-router-dom";
import {GeofenceEventAction} from "./GeofenceEventActionMenu";
import {useGeofenceEventMutation} from "../../../hooks/useGeofenceEventMutation";

export type UseGeofenceEventActionProps = {}

export type UseGeofenceEventActionResult = {
  onGeofenceEventActionClick: (geofenceEvent: GeofenceEventEntity, action: GeofenceEventAction) => void;
}

export const useGeofenceEventAction = (props: UseGeofenceEventActionProps = {}): UseGeofenceEventActionResult => {
  const {} = props

  const navigate = useNavigate();

  const {
    deleteGeofenceEvent,
  } = useGeofenceEventMutation()

  const _onGeofenceEventActionClick = useCallback((geofenceEvent: GeofenceEventEntity, action: GeofenceEventAction) => {
    if (action === "EDIT") {
      navigate(`/geofence-events/form`, {state: {id: geofenceEvent.id}})
    } else if (action === "DELETE") {
      deleteGeofenceEvent(geofenceEvent.id, undefined)
    }
  }, [navigate, deleteGeofenceEvent])

  return {
    onGeofenceEventActionClick: _onGeofenceEventActionClick
  }
}
